import { IsNumericRegex } from "@msidentity/SISU/components/inputs/input-regex-constants";
import {
  extractNLastPhoneDigits,
  validateEmailDomains,
  validateEmailInitials,
} from "@msidentity/SISU/model/alias";
import { replaceTokens } from "@msidentity/SISU/utilities/strings-helper";
import { emailAddressValidator } from "@msidentity/SISU/utilities/validators/email-validator";
import { usernameRecoverySelectAliasStringsFabric } from "../fabric/username-recovery-strings-fabric";
import { type UsernameRecoveryProofState } from "../username-recovery-context";

export const emailAliasHandler = (aliasInputValue: string, maskedAlias: string) => ({
  validate: () => {
    const emailValidation = emailAddressValidator(aliasInputValue);
    if (emailValidation === "Empty" || emailValidation === "Invalid") {
      return false;
    }

    return (
      validateEmailInitials(aliasInputValue, maskedAlias) &&
      validateEmailDomains(aliasInputValue, maskedAlias)
    );
  },
  error: () => {
    if (aliasInputValue.trim() === "") {
      return usernameRecoverySelectAliasStringsFabric.enterEmailError;
    }

    return usernameRecoverySelectAliasStringsFabric.incorrectEmailError;
  },
});

export const phoneAliasHandler = (aliasInputValue: string, maskedAlias: string) => ({
  validate: () => {
    if (aliasInputValue.trim().length !== 4) {
      return false;
    }

    if (!aliasInputValue.match(IsNumericRegex)) {
      return false;
    }

    return extractNLastPhoneDigits(aliasInputValue, 2) === extractNLastPhoneDigits(maskedAlias, 2);
  },
  error: () => {
    const enterDigitsError = replaceTokens(
      usernameRecoverySelectAliasStringsFabric.enterPhoneDigits,
      "4",
    );
    if (aliasInputValue.trim() === "") {
      return enterDigitsError;
    }

    return usernameRecoverySelectAliasStringsFabric.incorrectPhoneError;
  },
});

/**
 * Checks if the accounts for proof result contains both masked and unmasked aliases
 * @param proofState accounts for proof result
 * @returns boolean indicating if the accounts for proof result contains both masked and unmasked aliases
 */
export const containsMaskedAndUnmaskedAliases = (proofState: UsernameRecoveryProofState) =>
  proofState.aliases.some((alias) => alias.isUnmasked) &&
  proofState.aliases.some((alias) => !alias.isUnmasked);
